// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Em-z","zenCrossSiteLabel":"Fm-z","vrsnlCrossSiteLabel":"Gm-z"};